// Importing the Dexie library
import Dexie from 'dexie';

// Creating a new Dexie database instance named 'web3Dmails'
const db = new Dexie('securus');

// Defining the structure of the database with a single table named 'emails'
db.version(1).stores({
    inbox: '++id, mailId, decryptedMail',
    attachment: '++id, name, s3url, file',
    trash: '++id, mailId, decryptedMail',
    important: '++id, mailId, decryptedMail',
    sent: '++id, mailId, decryptedMail',
    spam: '++id, mailId, decryptedMail',
    category: '++id, mailId, decryptedMail',
});

export const deleteDatabase = async () => {
    Dexie.delete('securus').then(() => {
        console.log("Database deleted successfully.");
    }).catch(err => {
        console.error("Error deleting database:", err);
    });

    return true;
}

export default db;